const e = Object.freeze([]), t = Object.freeze(/* @__PURE__ */ Object.create(null));
export {
  e as EMPTY_ARRAY,
  t as EMPTY_OBJECT
};
